import type { TOC } from '@ember/component/template-only'
import type RexDashboardStudentSpellingLessonProgressIndexRoute from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/spelling-lesson-progress/index/route'
import RouteTemplate from 'ember-route-template'
import { DashboardStudentSpellingProgressPage } from 'teacher-ui-client/components/page/reporting/reading-eggspress/dashboard/student/spelling-progress'

interface Signature {
  Args: { model: ModelFor<RexDashboardStudentSpellingLessonProgressIndexRoute> }
}

export const DashboardStudentSpellingLessonProgressIndexPage: TOC<Signature> = <template>
  <DashboardStudentSpellingProgressPage
    @fetchSpellingProgressOverviewReportTask={{@model.fetchSpellingProgressOverviewReportTask}}
    @fetchSpellingProgressEventsReportTask={{@model.fetchSpellingProgressEventsReportTask}}
  />
</template>

export default RouteTemplate(DashboardStudentSpellingLessonProgressIndexPage)
